<template>
  <span class="country-time-clock">{{ displayText }}</span>
</template>

<script>
const TIMEZONES = {
  pk: 'Asia/Karachi',
  bd: 'Asia/Dhaka',
};

export default {
  name: 'CountryTimeClock',
  data() {
    return {
      now: new Date(),
      timer: null,
    };
  },
  computed: {
    countryCode() {
      return this.$store.state.isBD ? 'bd' : 'pk';
    },
    displayText() {
      const label = this.$t(`text.countryTime.${this.countryCode}`);
      const time = new Intl.DateTimeFormat('en-GB', {
        timeZone: TIMEZONES[this.countryCode],
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      }).format(this.now);
      return `${label} ${time}`;
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = new Date();
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style scoped lang="scss">
.country-time-clock {
  margin-right: 16px;
  font-size: 13px;
  color: #ffffff;
  white-space: nowrap;
}
</style>
